module.exports = __webpack_public_path__ + "static/sample_car_right_rear.3b4c5547.png";